/* eslint-disable consistent-return */
/* eslint-disable no-useless-escape */
/* eslint-disable eqeqeq */
/* eslint-disable curly */

export const hasNotNumericValues = value => {
    if (value) {
        return value.match(/^[ A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑçÇ'.-]+$/) !== null;
    } else {
        return true;
    }
};

export const phoneNum = value => {
    if (value) {
        return value.match(/^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/gm) !== null;
    } else {
        return true;
    }
};

export const passwordFormatValidation = password => {
    if (password === undefined) return true; // implica que viene desde edición de usuario

    // (?=.*[a-z]) One or more lowercase alphabetical character
    // (?=.*[A-Z]) One or more uppercase alphabetical character
    // (?=.*[0-9]) One or more numeric character
    // (?=.{6,}) At least 6 characters
    const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})');
    return !password ? false : password.match(passwordRegex) !== null;
};

export default {
    /**
     * @override
     */
    data() {
        return {
            DNI_REGEX: /^[0-9]{8,8}[A-Za-z]$/g,
            CIF_REGEX: /^([ABCDEFGHJKLMNPQRSUVW])([0-9]{7})([0-9A-J])$/,
            NIE_REGEX: /^[XYZ]{1}[0-9]{7,8}[A-Za-z]$/g,
            EMAIL_REGEX: /^\S+@\S+\.\S{2,6}$/
        };
    },

    methods: {
        /**
         * VALIDACIÓN DE DOCUMENTOS
         * Le pasamos un string con el valor que queremos validar y la función se encarga
         * de determinar qué tipo de documento es.
         * @param {String} str Valor que queremos validar
         * @param {String} type Tipo de documento a validar
         * @return {Object} Devuelve un objeto con la respuesta
         */
        validateSpanishID(str, type) {
            // Ensure upcase and remove whitespace
            str = str.toUpperCase().replace(/\s/, '');
            let valid = false;
            // Quitado, pasamos el tipo como parámetro para marcar como válido si no es [NIF | NIE | CIF]
            // const type = this.spainIdType(str);
            switch (type) {
                case 'NIF':
                case 'DNI':
                    valid = this.validDNI(str);
                    break;
                case 'NIE':
                    valid = this.validNIE(str);
                    break;
                case 'CIF':
                    valid = this.validCIF(str);
                    break;
                default:
                    valid = true;
                    break;
            }
            return {
                type,
                valid
            };
        },

        /**
         * Comprueba tipo de documento
         * @param {String} str Valor que queremos validar
         * @return {String} Devuelve tipo de documento
         */
        spainIdType(str) {
            if (str.match(this.DNI_REGEX)) {
                return 'NIF';
            }
            if (str.match(this.CIF_REGEX)) {
                return 'CIF';
            }
            if (str.match(this.NIE_REGEX)) {
                return 'NIE';
            }
        },

        /**
         * VALIDACIÓN DE DNI
         * @param {String} dni DNI para validar
         * @return {*} respuesta
         */
        validDNI(dni) {
            if (this.spainIdType(dni) !== 'NIF') {
                return false;
            }
            const dni_letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
            const letter = dni_letters.charAt(parseInt(dni, 10) % 23);

            return letter === dni.charAt(8).toUpperCase();
        },

        /**
         * VALIDACIÓN DE NIE
         * @param {String} nie NIE para validar
         * @return {*} respuesta
         */
        validNIE(nie) {
            if (this.spainIdType(nie) !== 'NIE') {
                return false;
            }
            // Change the initial letter for the corresponding number and validate as DNI
            let nie_prefix = nie.charAt(0);

            switch (nie_prefix) {
                case 'X':
                    nie_prefix = 0;
                    break;
                case 'Y':
                    nie_prefix = 1;
                    break;
                case 'Z':
                    nie_prefix = 2;
                    break;
                default:
                    break;
            }

            return this.validDNI(nie_prefix + nie.substr(1));
        },

        /**
         * VALIDACIÓN DE CIF
         * @param {String} cif CIF para validar
         * @return {*} respuesta
         */
        validCIF(cif) {
            if (this.spainIdType(cif) !== 'CIF') {
                return false;
            }
            const match = cif.match(this.CIF_REGEX);
            const letter = match[1];
            const number = match[2];
            const control = match[3];

            let even_sum = 0;
            let odd_sum = 0;
            let n;

            for (let i = 0; i < number.length; i++) {
                n = parseInt(number[i], 10);

                // Odd positions (Even index equals to odd position. i=0 equals first position)
                if (i % 2 === 0) {
                    // Odd positions are multiplied first.
                    n *= 2;

                    // If the multiplication is bigger than 10 we need to adjust
                    odd_sum += n < 10 ? n : n - 9;

                    // Even positions
                    // Just sum them
                } else {
                    even_sum += n;
                }
            }

            const control_digit = 10 - (even_sum + odd_sum).toString().substr(-1);
            const control_letter = 'JABCDEFGHI'.substr(control_digit, 1);

            // Control must be a digit
            if (letter.match(/[ABEH]/)) {
                return Number(control) === control_digit;
            } else if (letter.match(/[KPQS]/)) {
                return control === control_letter;
            } else {
                return control == control_digit || control === control_letter;
            }
        },

        /**
         * Validación de email
         * @param {String} email to validate
         * @return {Boolean} valid or not
         */
        validateEmail(email) {
            return this.EMAIL_REGEX.test(String(email).toLowerCase());
        },

        /**
         * Validar campos requeridos
         * @param {*} requiredProperties Listado de campos
         * @param {*} valid valor de la validación
         * @return {Boolean} validación
         */
        validateRequired(requiredProperties, valid = true) {
            requiredProperties.forEach(required => {
                if (!this.formattedData[required]) {
                    if (process.env.NODE_ENV === 'development') {
                        console.warn(` - Campo requerido: ${required} `);
                    }
                    valid = false;
                    this.$refs[`${required}-${this.key}`].$el.classList.add('creation-error');
                }
            });
            return valid;
        },

        /**
         * Validar campos requeridos de formato fecha
         * @param {*} requiredProperties Listado de campos de fecha
         * @param {*} valid valor de la validación
         * @return {Boolean} validación
         */
        validateRequiredDate(requiredProperties, valid = true) {
            requiredProperties.forEach(required => {
                if (!this.formattedData[required] &&
                    !this.$refs[`${required}-${this.key}`].getElementsByClassName('form-control')[0].disabled) {
                    if (process.env.NODE_ENV === 'development') {
                        console.warn(` - Campo requerido: ${required} `);
                    }
                    valid = false;
                    this.$refs[`${required}-${this.key}`].getElementsByClassName('form-control')[0].classList.add('creation-error');
                }
            });
            return valid;
        },

        /**
         * Validar campos no numericos
         * @param {*} noNumericFields Listado de campos con formato no numérico
         * @param {*} valid valor de la validación
         * @return {Boolean} validación
         */
        validateNoNumericFields(noNumericFields, valid = true) {
            noNumericFields.forEach(field => {
                if (this.formattedData[field]) {
                    if (/\d/.test(this.formattedData[field])) {
                        valid = false;
                        this.$refs[`${field}-${this.key}`].$el.classList.add('creation-error');
                    }
                }
            });
            return valid;
        },

        /**
         * Limpia los errores
         */
        cleanErrors() {
            const errors = document.getElementsByClassName('creation-error');
            for (let i = 0; i < errors.length; i++) {
                const element = errors[i];
                element.classList.remove('creation-error');
            }
        }
    }
};

